import Action from 'ageas-react-component-action'
import MainLoader from 'ageas-react-component-loader'
import Modal from 'ageas-react-component-modal'
import PageTitle from 'ageas-react-component-pagetitle'
import TextField from 'ageas-react-component-textfield'

import { useEffect } from 'react'
import { MainContainer } from '../../../GlobalStyles'
import { useQuotationStore } from '../../../Stores/useQuotationStore'
import { CONTEXT_DOCUMENT } from '../../../constants/contextDocument'
import { useRequestQuotation } from '../../../hooks/api/requestQuotation/useRequestQuotation'
import { useRequestQuotationPayload } from '../../../hooks/api/requestQuotation/useRequestQuotationPayload'
import { t } from '../../../i18n'
import { ModalComponent } from '../../ModalComponent'
import { ToggleTableAttachment } from '../../QuoteRequestStatus/Contents/ToggleTableAttachment'
import { TabPageContainer } from '../../QuoteRequestStatus/styles'
import { ButtonNextContainer, FormContainer } from '../styles'

type Props = {
  isVisible: boolean
  closeAction?: () => void
}

export const RequestAuthorization = ({ isVisible, closeAction }: Props) => {
  const { updateQuotation } = useQuotationStore()
  const { mutate, isSuccess, isLoading } = useRequestQuotation()

  const requestQuotationPayload = useRequestQuotationPayload()

  useEffect(() => {
    if (isSuccess && closeAction) {
      closeAction()
    }
  }, [isSuccess])

  return (
    <>
      <MainLoader show={isLoading} />
      <ModalComponent show={isVisible}>
        <Modal
          show={isVisible}
          hideCloseAction={false}
          closeAction={closeAction}
          content={
            <MainContainer>
              <PageTitle
                id="title"
                name={t('pages.step5.requestAuthorization.title')}
              />
              <FormContainer>
                <div className="row">
                  <div className="col">
                    <TextField
                      id="tf-agent-observations"
                      name="tf-agent-observations"
                      label={t(
                        'pages.step5.requestAuthorization.agentObservations',
                      )}
                      value=""
                      onValueChanged={(id: string, value: string) => {
                        updateQuotation({ agentObservations: value })
                      }}
                      colorTheme="blue"
                      maxLength={200}
                      version="2"
                    />
                  </div>
                  <div className="col">
                    <TextField
                      id="tf-comercial-study"
                      name="tf-comercial-study"
                      label={t(
                        'pages.step5.requestAuthorization.comercialStudy',
                      )}
                      value=""
                      onValueChanged={(id: string, value: string) => {
                        updateQuotation({ commercialStudy: value })
                      }}
                      colorTheme="blue"
                      maxLength={70}
                      version="2"
                    />
                  </div>
                </div>
                <div className="row">
                  <div className="col">
                    <TextField
                      id="tf-coverage-details"
                      name="tf-coverage-details"
                      label={t(
                        'pages.step5.requestAuthorization.coverageDetails',
                      )}
                      value=""
                      onValueChanged={(id: string, value: string) => {
                        updateQuotation({ conditionDetails: value })
                      }}
                      colorTheme="blue"
                      maxLength={70}
                      version="2"
                    />
                  </div>
                  <div className="col">
                    <TextField
                      id="tf-related-entities"
                      name="tf-related-entities"
                      label={t(
                        'pages.step5.requestAuthorization.relatedEntities',
                      )}
                      value=""
                      onValueChanged={(id: string, value: string) => {
                        updateQuotation({ relatedEntityNIF: value })
                      }}
                      colorTheme="blue"
                      maxLength={70}
                      version="2"
                    />
                  </div>
                </div>
                <div className="row">
                  <div className="col">
                    <TextField
                      id="tf-factors-other"
                      name="tf-factors-other"
                      label={t('pages.step5.requestAuthorization.factorsOther')}
                      value=""
                      onValueChanged={(id: string, value: string) => {
                        updateQuotation({ otherRiskFactors: value })
                      }}
                      colorTheme="blue"
                      maxLength={70}
                      version="2"
                    />
                  </div>
                  <div className="col" />
                </div>
              </FormContainer>
              <TabPageContainer>
                <ToggleTableAttachment
                  context={CONTEXT_DOCUMENT.QUOTATION_REQUEST}
                />
              </TabPageContainer>
              <ButtonNextContainer>
                <div className="button-action">
                  <Action
                    id="actionSendReportPDFtoEmail"
                    onValueChanged={() =>
                      mutate(
                        requestQuotationPayload(
                          CONTEXT_DOCUMENT.QUOTATION_REQUEST,
                        ),
                      )
                    }
                    colorTheme="blue"
                    label={t('pages.step5.requestAuthorization.submit')}
                    disable={false}
                  />
                </div>
              </ButtonNextContainer>
            </MainContainer>
          }
        />
      </ModalComponent>
    </>
  )
}
